<template>
	<ul :class="['random-playlist', isActive(program, program.primary.program_start, program.primary.program_end) ? 'active' : '' ]">
	  <li v-for="(video, index) in shuffledVideos" :key="video.id" :class="isActive(index) ? 'active-video' : ''">
	    {{ video.video_title }}
	  </li>
	</ul>
</template>

<style>

</style>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'RandomPlayback',
  props: ['videos', 'active'],
  components: {
  },
  computed: {
  },
  data () {
    return {
	    currentTime: null,
	    activeId: '',  
			shuffledVideos: [] 
    }
  },
	methods: {
		getContent () {
			var videos = _.shuffle(this.videos);
		  this.shuffledVideos = videos;
		  this.activeId = 0;
	  },
	  isActive (index) {
		  if (this.activeId == index) {
		  return true } else { return false }
	  },
	  updateCurrentTime() {
      this.currentTime = moment().local()
    },
    getVideo () {
						
			function playArray(index,ele,array,listener){
				ele.loop = false;
		    ele.src = array[index].video_link.url;
		    ele.load();
		    setTimeout(function() {
				  ele.play();
				}, 0);
		    index++;
		    
		    if(index>=array.length){
		        index=0;
		    }
		    listener = ele.addEventListener('ended',function(){

      		this.activeId = index;
		      playArray(index,ele,array,listener);
		    },false);
			}
			
			playArray(0,document.getElementById('rb-video'),this.shuffledVideos);
	    
    }
 	},
	created () {
	  this.getContent();
	  this.currentTime = moment();
  },
  mounted () {
	  this.getVideo();
  }
}
</script>